import store from './store';
import wpJsonRequest from './wp-json-request';

wpJsonRequest({uri: '/wp-json/wp/v2/users'})
	.then(result => {
		store.dispatch({
			type: 'SET_USERS',
			payload: result
		});
	});


// WEBPACK FOOTER //
// ./src/populateState.js